import ADMIN_PERMISSIONS from '@/constants/authorization/admin-permissions'

export default [
  {
    header: 'navigation.marketing',
  },
  {
    title: 'navigation.automated-notifications',
    route: 'super:notifications',
    adminPermissions: [ADMIN_PERMISSIONS.NOTIFICATIONS],
    icon: 'BellIcon',
  },
  {
    title: 'navigation.newsletter',
    route: 'super:newsletter',
    adminPermissions: [ADMIN_PERMISSIONS.NOTIFICATIONS],
    icon: 'MailIcon',
  },
  {
    title: 'navigation.coupons',
    route: 'super:coupons',
    adminPermissions: [ADMIN_PERMISSIONS.COUPONS],
    icon: 'GiftIcon',
  },
  {
    title: 'navigation.create-qr',
    route: 'super:create-qr',
    icon: 'CameraIcon',
  },
  {
    title: 'navigation.marketing-channel',
    route: 'super:marketing-channels',
    adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS],
  },
]
